import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export type initialFilterStateProps = {
  memNo: string;
  emlId: string;
  mobCntyCd: string;
  mobNo: string;
  uYn: string;
};

// Filter Context
export interface UserFilterContextType {
  filters: initialFilterStateProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onReset: () => void;
}

const UserFilterContext = createContext<UserFilterContextType | undefined>(
  undefined
);

interface UserFilterProviderProps {
  children: ReactNode;
}

export const UserFilterProvider = ({ children }: UserFilterProviderProps) => {
  const initialFilterState = {
    memNo: "",
    emlId: "",
    mobCntyCd: "+82",
    mobNo: "",
    uYn: "",
  };

  const [filters, setFilters] =
    useState<initialFilterStateProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onReset = () => {
    setFilters(initialFilterState);
  };

  return (
    <UserFilterContext.Provider
      value={{
        filters,
        onChange,
        onSelect,
        onReset,
      }}
    >
      {children}
    </UserFilterContext.Provider>
  );
};

export const useUserFilterContext = (): UserFilterContextType => {
  const context = useContext(UserFilterContext);

  if (!context) {
    throw new Error(
      "useUserFilterContext는 UserFilterProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};

// Params Conext
interface UserParamsContextType {
  param: Partial<initialFilterStateProps> | undefined;
  setParam: Dispatch<
    SetStateAction<Partial<initialFilterStateProps> | undefined>
  >;
}

const UserParamsContext = createContext<UserParamsContextType | undefined>(
  undefined
);

interface UserParamsProviderProps {
  children: ReactNode;
}

export const UserParamsProvider = ({ children }: UserParamsProviderProps) => {
  const [param, setParam] = useState<
    Partial<initialFilterStateProps> | undefined
  >(undefined);

  return (
    <UserParamsContext.Provider
      value={{
        param,
        setParam,
      }}
    >
      {children}
    </UserParamsContext.Provider>
  );
};

export const useUserParamsContext = (): UserParamsContextType => {
  const context = useContext(UserParamsContext);

  if (!context) {
    throw new Error(
      "useUserParamsContext는 UserParamsProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
